import { render, staticRenderFns } from "./ChevronIcon.vue?vue&type=template&id=55a924af&scoped=true"
import script from "./ChevronIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChevronIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChevronIcon.vue?vue&type=style&index=0&id=55a924af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a924af",
  null
  
)

export default component.exports